// features/bookmarks/BookmarkSortMenu.tsx — Recent/Oldest dropdown.
import { useState } from 'react';
import styled from 'styled-components';
import { Popover } from '@/ui';
import { Icon } from '@/icons';
import { SORTS } from './meta';
import type { SortId } from './meta';

export interface BookmarkSortMenuProps {
  active: SortId;
  onChange: (sort: SortId) => void;
}

const Trigger = styled.button`
  display: inline-flex; align-items: center; gap: 6px; cursor: pointer;
  padding: 8px 12px; border-radius: ${({ theme }) => theme.radius.md};
  background: ${({ theme }) => theme.color.glassBg};
  border: 1px solid ${({ theme }) => theme.color.glassBorder};
  font-family: ${({ theme }) => theme.font.body}; font-size: ${({ theme }) => theme.fontSize.sm};
  color: ${({ theme }) => theme.color.textPrimary};
`;
const Menu = styled.div`min-width: 160px; display: flex; flex-direction: column;`;
const Item = styled.button<{ $active: boolean }>`
  display: flex; align-items: center; gap: 8px; width: 100%; padding: 8px 10px;
  border: none; background: transparent; cursor: pointer; border-radius: ${({ theme }) => theme.radius.sm};
  font-family: ${({ theme }) => theme.font.body}; font-size: ${({ theme }) => theme.fontSize.sm};
  color: ${({ theme }) => theme.color.textPrimary};
  font-weight: ${({ $active }) => ($active ? 700 : 500)};
  &:hover { background: ${({ theme }) => theme.color.glassBorder}; }
`;

export function BookmarkSortMenu({ active, onChange }: BookmarkSortMenuProps) {
  const [open, setOpen] = useState(false);
  const label = SORTS.find((s) => s.id === active)?.label ?? 'Most Recent';
  return (
    <Popover
      open={open}
      onOpenChange={setOpen}
      trigger={<Trigger type="button">{label}<Icon name="chevron-down" size={14} /></Trigger>}
    >
      <Menu>
        {SORTS.map((s) => (
          <Item key={s.id} type="button" role="menuitemradio" aria-checked={s.id === active}
            $active={s.id === active}
            onClick={() => { onChange(s.id); setOpen(false); }}>
            {s.label}
          </Item>
        ))}
      </Menu>
    </Popover>
  );
}
